module.exports = __webpack_public_path__ + "static/img/send_success_icon.9edbe72d.png";